module.exports = __webpack_public_path__ + "assets/img/small_tablet_icon.29e85383.svg";